module.exports = __webpack_public_path__ + "img/dolbal.9019b491.jpg";